import L, { LatLngExpression } from "leaflet";
import { ATTR_OSM, ATTR_OVERPASS } from "../MapProps";

export function createMapInDiv(center: LatLngExpression, basemap?: any, zoom?: number): L.Map {
  return L.map("leaflet-map", {
    center,
    zoom: zoom || 13,
    layers: [
      basemap
      // L.tileLayer("http://{s}.tile.osm.org/{z}/{x}/{y}.png", { attribution: [ATTR_OSM, ATTR_OVERPASS].join(", ") }) //TODO: move this to baselayers
    ],
    scrollWheelZoom: true,
    touchZoom: true,
    dragging: true,
    doubleClickZoom: true,
    boxZoom: true,
    keyboard: true
  });
}
